import { IMessage } from "@/types";

interface MessageOptions {
  content: string;
  role?: "user" | "assistant" | "system";
  conversation_id?: string;
  display_files?: any;
  error_messages?: string | null;
  has_error?: boolean;
  is_streaming?: boolean;
  metadata?: Record<string, any>;
  sequence_number?: number;
  status?: string | null;
}
export function createMessage({
  content,
  role = "user",
  conversation_id = "",
  display_files = null,
  error_messages = null,
  has_error = false,
  is_streaming = true,
  metadata = {},
  sequence_number = 0,
  status = null,
}: MessageOptions): IMessage {
  const now = new Date();

  return {
    id: `temp-${crypto.randomUUID()}`,
    content,
    role,
    conversation_id,
    created_at: now,
    updated_at: now,
    display_files,
    error_messages,
    has_error,
    is_streaming,
    metadata,
    sequence_number,
    status,
  };
}
